import Grid from '@mui/material/Grid';
import LeadViewRight from 'src/features/leads/view/LeadViewRight';
import FiltersAndGrouping from 'src/features/leads/list/FiltersAndGrouping';
import EditLeadView from 'src/features/leads/view/EditLeadView';
import FilterContainer from 'src/features/common/FilterContainer';
import LeadsList from 'src/features/leads/list/LeadsList';
import ByCountryList from 'src/features/leads/list/ByCountryList';
import { LeadScreenStore, GroupType, ViewType, FilterSingleLead, Lead, DashboardViewStore } from 'src/stores/LeadStore'
import { useState } from 'react';
import { IconButton } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { v4 as uuid } from 'uuid';
import LeadSummaryView from '../leads/view/LeadSummaryView';
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
import Button from '@mui/material/Button';

const DashboardLead = () => {

    const selectedView = LeadScreenStore.useState(s => s.selectedView);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead) as Lead;

    const goBack = () => {
        DashboardViewStore.update(s => { s.activityDate = '' });
        DashboardViewStore.update(s => { s.showTodoList = true });
        DashboardViewStore.update(s => { s.showActivityWorkList = false });
        DashboardViewStore.update(s => { s.showInboundCallList = false });
        DashboardViewStore.update(s => { s.showDefault = true });
        DashboardViewStore.update(s => { s.showDetail = false });
        DashboardViewStore.update(s => { s.showTaskList = false });
        FilterSingleLead.update(s => { s.filterSingleLead = false });
        
    };


    return <>
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Box sx={{ p: 5, pb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ mr: 4, mb: 2 }}>
                        <Tooltip title="Go Back" >
                            <Button size='small' variant="outlined" color="info" startIcon={<ArrowBackTwoToneIcon />} sx={{ mr: 3 }} onClick={goBack}>
                                    Back to Dashboard
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12} md={5} lg={5}>
                <LeadSummaryView item={selectedLead} />
            </Grid>
            <Grid item xs={12} md={7} lg={7}>
                <LeadViewRight />
            </Grid>
        </Grid>


        {selectedView == ViewType.Edit && <EditLeadView />}
    </>
}


export { DashboardLead }

export default DashboardLead;